<template src="./template.html"></template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import categoryValuesApi from '@/api/categoryValues'
import containersApi from '@/api/container'

export default {
  name: 'company_container_type',
  data() {
    return {
      container: {},
      identifier: {},
      identifier_type_values: [],
      custom_identifier_type: '',
      templateMode: 'edit',
      categoryParams: { context: 'containers', category: 'identifier_type' },
    }
  },
  components: { BreadCrumbs, CompanyNav, SectionHeader },
  computed: {
    trimmedIdentifier() {
      const val = this.identifier
      return { ...val, name: val.name.trim(), value: val.value.trim() }
    },
  },
  methods: {
    submitIdentifier: async function () {
      const result = await containersApi.identifiers.update(
        this.$route.params.container_uuid,
        this.$route.params.identifier_uuid,
        this.trimmedIdentifier,
      )
      if (result.success) {
        await this.$router.push(`/company/containers/${this.$route.params.container_uuid}`)
      }
    },
  },
  async mounted() {
    this.container = await containersApi.get(this.$route.params.container_uuid)
    this.identifier = await containersApi.identifiers.get(
      this.$route.params.container_uuid,
      this.$route.params.identifier_uuid,
    )
    const { context, category } = this.categoryParams
    const categoryValues = await categoryValuesApi.get(context, category)
    this.identifier_type_values = categoryValues
  },
}
</script>
